export default function componentForCollection(
  collectionIdentifier,
  selectKit
) {
  return selectKit.modifyComponentForCollection(collectionIdentifier);
}
